const maintenanceRequests = (maintenanceRequests = [], action) => {
  switch (action.type) {
    case 'FETCH_MAINTENANCE_REQUESTS':
      return action.payload
    default:
      return maintenanceRequests
  }
}
export default maintenanceRequests
